import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs'

import { AstrolyticsService } from "../../_services/astrolytics.service";
import { AuthenticationService } from '../../_services/authentication.service';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

@Component({
  selector: 'app-seller-page',
  templateUrl: './seller-page.component.html',
  styleUrls: ['./seller-page.component.css']
})
export class SellerPageComponent implements OnInit {

  protected seller_name;
  protected seller_id;
  protected source_category;
  
  protected error;

  filterAndSortArray(ar){

    var ret = [];    
    for (let data in ar){            
      if (ar[data].percentage > 0){
        ret.push(ar[data])
      }            
    }

    ret.sort(function (a, b) {            
      return b.percentage - a.percentage;      
    });  




    var total_popped = 0;
    while (ret.length > 14){      
      var x = ret.pop();
      total_popped+= x.percentage;      
    }
        

    if (total_popped > 0){      
      ret.push({ name : "Otros", percentage: Math.round(total_popped), id: "0"});
    }
    
    return ret;
  }

  sellerSubscription : Subscription;
  protected category_revenue_graph;
  protected data;
  protected categories;  

  protected loading;

  constructor(private astrolyticsService: AstrolyticsService, private authenticationService: AuthenticationService,private route: ActivatedRoute) { 
    this.loading = true;
  }

  ngOnInit() {
    registerLocaleData(localeFr, 'fr');
    this.seller_name =this.route.snapshot.queryParamMap.get("name");
    this.seller_id = this.route.snapshot.queryParamMap.get("id");
    this.source_category = this.route.snapshot.queryParamMap.get("source");    

    this.sellerSubscription = this.astrolyticsService.sellerDataObservable.subscribe( message => {   

        try {
          if (message.category_revenue_graph) {
            this.loading = false;
          }
          var ax =  this.filterAndSortArray(message.category_revenue_graph);
          this.category_revenue_graph = ax;
          this.data = message;
          var categories = [];
          for (let cat in message.categories){
            message.categories[cat].category = cat;
            categories.push(message.categories[cat]);
          }
          categories.sort(function (a,b){
            return b.total_revenue - a.total_revenue 
          });
          this.categories = categories;
          console.log(message);  
        } catch (error) {
          console.log(error);
          this.loading = false;
          this.error = true;
        }
          
    });
    
    this.astrolyticsService.getSellerData(this.seller_id);
    
  }

  ngOnDestroy() {        
    this.sellerSubscription.unsubscribe();    
    this.data = undefined;
    this.categories = undefined;
    this.category_revenue_graph = undefined;    
  }

  downloadExcel() {
    console.log("Descargando Excel");
    this.data["seller_name"] = this.seller_name;
    this.astrolyticsService.downloadSellerExcel(this.data);
  }

}
